module.exports = __webpack_public_path__ + "static/img/aboutyixi.8b3925cc.png";